import { render, staticRenderFns } from "./Check.vue?vue&type=template&id=48fba697"
import script from "./Check.vue?vue&type=script&lang=js"
export * from "./Check.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports